<ds-empty-state
  heading="Company Car Self Service Portal"
  description="This application allows employees to configure their driver information in regards to employee lease program."
  illustration="create-2"
  size="lg"
>
</ds-empty-state>
